import { render, staticRenderFns } from "./PTScheduleDetails.vue?vue&type=template&id=a420ff5e&"
import script from "./PTScheduleDetails.vue?vue&type=script&lang=js&"
export * from "./PTScheduleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports